import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { GetEventJudgeStore } from 'SessionState/Judge/EventJudgeStore';

type JudgeTabulatorHelpMessageProps = {
  show: boolean;
  onHide: () => void;
  initialMessage?: string;
   mode?: 'judge-help' | 'login-help';
};

const JudgeTabulatorHelpMessage: React.FC<JudgeTabulatorHelpMessageProps> = ({
  show,
  onHide,
  initialMessage = '',
    mode = 'judge-help',
}) => {
  const judgeStore = GetEventJudgeStore();
  const judge = judgeStore.CurrentJudge;

  const [message, setMessage] = useState('');
  const [judgeName, setJudgeName] = useState('');
  const [eventName, setEventName] = useState('');

useEffect(() => {
  if (show) {
    setMessage(initialMessage ?? '');
    setJudgeName('');
    setEventName('');
  }
}, [show, initialMessage]);

  const [isSending, setIsSending] = useState(false);

  const handleSend = async () => {
    const trimmed = message.trim();

    if (!trimmed) {
      toast.warning('Please enter a message first.');
      return;
    }

    if (mode === 'login-help') {
  if (!judgeName.trim() || !eventName.trim()) {
    toast.warning('Please enter your name and pageant name.');
    return;
  }
}
    setIsSending(true);

    try {
 if (mode === 'login-help') {
  await (judgeStore as any).sendJudgeLoginHelpMessage({
    judgeName: judgeName.trim(),
    eventName: eventName.trim(),
    message: trimmed,
  });
} else {
  await (judgeStore as any).sendJudgeTabulatorHelpMessage({
    eventJudgeId: judge?.id,
    eventId: judge?.eventId,
    judgeLabel: judge?.judgeLabel,
    judgeName: judge?.judgeName,
    accessCodeLast4: judge?.accessCodeLast4,
    eventName: judge?.eventName,
    message: trimmed,
  });
}

      toast.success('Your message has been sent to the tabulator.');
      setMessage('');
      onHide();
    } catch (error) {
      console.error('Failed to send judge help message', error);
      toast.error('Unable to send message. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal show={show} onHide={isSending ? undefined : onHide} centered>
      <Modal.Header closeButton={!isSending}>
        <Modal.Title>Message the Tabulator</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="small text-muted mb-3">
          Send a message if you are having trouble scoring or need assistance.
        </div>

        {mode === 'login-help' && (
  <>
    <Form.Group className="mb-3">
      <Form.Label>Your Name</Form.Label>
      <Form.Control
        value={judgeName}
        disabled={isSending}
        placeholder="Your name"
        onChange={(event) => setJudgeName(event.currentTarget.value)}
      />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Pageant Name</Form.Label>
      <Form.Control
        value={eventName}
        disabled={isSending}
        placeholder="Pageant name"
        onChange={(event) => setEventName(event.currentTarget.value)}
      />
    </Form.Group>
  </>
)}

        <Form.Group>
          <Form.Label>Your Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={message}
            disabled={isSending}
            maxLength={500}
            placeholder="Example: I am having trouble saving scores for contestant #12."
            onChange={(event) => setMessage(event.currentTarget.value)}
          />
          <div className="text-end small text-muted mt-1">
            {message.length}/500
          </div>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={isSending}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSend} disabled={isSending}>
          {isSending ? (
            <>
              <Spinner size="sm" className="me-2" />
              Sending...
            </>
          ) : (
            'Send Message'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JudgeTabulatorHelpMessage;